import React from 'react'
import { motion } from 'framer-motion'

interface ErrorStateProps {
  error: Error
  onRetry: () => void
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="min-h-screen flex items-center justify-center p-6"
    >
      <div className="max-w-md w-full text-center space-y-6">
        <motion.div
          animate={{ rotate: [0, 10, -10, 10, 0] }}
          transition={{ duration: 0.5 }}
          className="text-6xl"
        >
          ⚠️
        </motion.div>
        <div className="space-y-3">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
            Ошибка загрузки
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            {error.message || 'Не удалось загрузить данные'}
          </p>
        </div>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onRetry}
          className="px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-xl font-medium"
        >
          Попробовать снова
        </motion.button>
      </div>
    </motion.div>
  )
}